import { createTheme, Components, Theme } from '@mui/material/styles';
import muiTooltipStyles from '@styles/components/mui-tooltip-styles.ts';

const getCSSVariable = (variable: string) =>
  typeof document !== 'undefined'
    ? getComputedStyle(document.documentElement)
        .getPropertyValue(variable)
        .trim()
    : '';

const muiTimePickerStyles = {
  MuiPaper: {
    styleOverrides: {
      root: {
        '&.MuiPickerPopper-paper': {
          padding: '8px !important'
        }
      }
    }
  },
  MuiMenuItem: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: 'var(--primary) !important',
          color: 'white',
          '&::after': {
            display: 'none !important'
          }
        },
        '&:hover': {
          color: 'var(--primary) !important',
          backgroundColor: 'var(--gray-11) !important'
        }
      }
    }
  },

  MuiPickersDay: {
    styleOverrides: {
      root: {
        '&.Mui-selected': {
          backgroundColor: 'var(--primary) !important',
          '&:hover': {
            backgroundColor: 'var(--primary) !important'
          },
          '&:focus': {
            backgroundColor: 'var(--primary) !important'
          }
        }
      }
    }
  },

  MuiDialogActions: {
    styleOverrides: {
      root: {
        '&.MuiPickersLayout-actionBar': {
          paddingBottom: '0px !important',
          '& .MuiButton-root': {
            minWidth: 'auto !important',
            color: 'var(--primary) !important',
            '&:hover': {
              backgroundColor: 'var(--gray-11)'
            }
          }
        }
      }
    }
  }
};

export const customTimePickerTheme = createTheme({
  palette: {
    primary: {
      main: getCSSVariable('--primary') || '#7136ED'
    }
  },

  components: {
    ...muiTooltipStyles,
    ...muiTimePickerStyles
  } as Components<Theme>
});
